module.exports = __webpack_public_path__ + "static/media/index.fd47014c.cjs";